import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { CustomIcons } from '@shared/models/custom-icons';
import { getAllChildTagsForTd } from '@utils/other-utils';
import { Router } from '@angular/router';
import { map } from 'rxjs';
import { AppStateService } from '../../services/app-state.service';
import { ImpairedSorting } from '../../../data/models/data-table';
import { AppInfo, ApplicationStore } from '../../models/platfrom';
import { VersionForVisuallyImpairedRoutes } from '../../../../models/routes';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableComponent implements OnInit {
  public sorting: ImpairedSorting;
  public icons = CustomIcons;
  public appData$ = this.appState.filterApp.pipe(
    map(apps => apps.map(app => ({
      ...app,
      appStores: this.groupedPlatforms(app),
    }))),
  );
  constructor(private appState: AppStateService, private router: Router) {}

  public ngOnInit(): void {
    this.sorting = this.appState.sorting;
  }

  public changeSorting(name: string): void {
    this.sorting = {
      value: this.sorting.value === 'ASC' ? 'DESC' : 'ASC',
      type: name
    };

    this.appState.sorting = this.sorting;
    this.appState.filterPlatforms();
  }

  public openApp(event: MouseEvent, app: AppInfo): void {
    const topTags = ['APP-BUTTON-ICON'];
    const parentTags = getAllChildTagsForTd(topTags, event.target as HTMLElement);
    if (!parentTags.some(parentTag => topTags.some(topTag => topTag === parentTag))) {
      this.router.navigate([`/visually-impaired/${VersionForVisuallyImpairedRoutes.Apps}`, app.id]);
    }
  }

  public goAppStore(link: string): void {
    if (window) {
      window.open(link, '_blank');
    }
  }

  private groupedPlatforms(app: AppInfo): ApplicationStore[] {
    const platforms = ['Android' ,'iOS', 'Windows Phone'];

    return platforms.reduce((appPlatforms: ApplicationStore[], platformName: string) => {
      const apps = app.appStores.filter(store => store.platform === platformName);
      return [...appPlatforms, ...apps];
    }, []);
  }
}
